<button mat-raised-button (click)="navigateToProductCreate()" color="primary">
  Novo Produto
</button>

<app-product-read></app-product-read>
